import { Trans } from 'react-i18next';
import { useLocation } from 'react-router';
import { Link } from 'react-router-dom';

import { Tooltip } from '@shared/ui/components/Tooltip';
import { cn } from '@shared/utils/helpers';

type MenuItemProps = {
  title: string;
  to: string;
  disabled?: boolean;
  tip?: string;
};

export function MenuItem({ title, to, disabled, tip }: MenuItemProps) {
  const location = useLocation();

  const active = location.pathname.startsWith(to);

  const contents =
    disabled === true ? (
      <span className="block w-full px-17 py-2 text-[#868aa8] opacity-75 line-through">
        <Trans>{title}</Trans>
      </span>
    ) : (
      <Link
        to={to}
        className={cn('block w-full px-17 py-2 text-[#868aa8] hover:bg-[#292b3a] no-underline cursor-pointer', {
          'text-[#716aca]': active,
        })}
      >
        <Trans>{title}</Trans>
      </Link>
    );

  if (tip) {
    return (
      <li aria-current={active ? 'true' : 'false'}>
        <Tooltip content={tip}>{contents}</Tooltip>
      </li>
    );
  }

  return <li aria-current={active ? 'true' : 'false'}>{contents}</li>;
}
